import { Spin, Card, Button, Typography, Flex, Select, message } from "antd";
import { withRouter } from "react-router-dom";
import { push } from "react-router-redux";
import React, { Component } from "react";
import { connect } from "react-redux";

import { dashboardActions } from "../../../../actions";
import { controller } from "../../../../controller";
import "../../../app.local.css";
import "./dashboardStyle.css";

import TreatmentPaymentLabel from "./TreatmentPaymentLabel";
import PaymentRequestsTable from "./PaymentReuestsTable";
import PaymentRequestPage from "./PaymentRequestPage";

//ICONS
// import leftArrow from "../../../../assets/icons/arrow-left.svg";
import cardTick from "../../../../assets/icons/card-tick.png";
import money from "../../../../assets/icons/money.png";

class DashboardPage extends Component {
  async componentDidMount() {
    this.updateWindowDimensions();
    this.getGuarantors();
    window.addEventListener("resize", this.updateWindowDimensions);
    localStorage.removeItem("treatment.pat_id");
    localStorage.removeItem("treatment.pat_name");
    localStorage.removeItem("treatment.gurantor.name");
    localStorage.removeItem("treatment.guarantor.id");
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.selectedGuarantor !== this.state.selectedGuarantor ||
      prevState.page !== this.state.page ||
      prevState.page_size !== this.state.page_size ||
      prevState.search_term !== this.state.search_term
    ) {
      if (this.state.selectedGuarantor) {
        this.updateRequestList();
      }
    }
  }

  getGuarantors = async () => {
    try {
      this.setState({ isGettingGuarantors: true });

      const response = await controller.updateGetAR("", "", "", "", "", "", "", "", this.props.selectedPatient.id);

      if (response.results.length > 0) {
        const { amount_between_0_30, amount_between_31_60, amount_between_61_90, amount_greater_than_90 } = response.results[0];
        const arAmounts = [amount_between_0_30, amount_between_31_60, amount_between_61_90, amount_greater_than_90]
          .map((amount) => Number(amount.slice(1)))
          .reduce((cur, acc) => acc + cur, 0);

        console.log(response);
        console.log(response.results[0]);
        console.log(response.results[0].guarantor);
        console.log(response.results[0].guarantor.id);
        this.setState({
          guarantors: response.results.map((ar) => ({
            value: ar.guarantor.id,
            label: `${ar.guarantor.firstname} ${ar.guarantor.lastname || ""}`,
          })),
          arList: response.results,
          selectedGuarantor: response.results[0].guarantor.id,
          defaultAmount: response.results[0].total_amount,
          selectedAR: response.results[0],
          sumOfARAmounts: arAmounts,
        });

        this.updateRequestList();
      }
    } catch (err) {
      message.error("Something went wrong while getting guarantors");
      console.error(err);
    } finally {
      this.setState({ isGettingGuarantors: false });
    }
  };

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  constructor(props) {
    super(props);

    this.state = {
      serverLogo: "",
      width: 0,
      height: 0,
      page_size: 25,
      page: 1,
      search_term: "",
      totalAr: "",
      openDetailModal: false,
      isGettingPaymentsData: false,
      showPaymentRequestForm: false,
      isSyncing: false,
      isGettingCardsData: false,
      isGettingGuarantors: false,
      guarantors: [],
      paymentRequests: [],
      arList: [],
      selectedGuarantor: undefined,
      selectedAR: undefined,
      sumOfARAmounts: 0,
      defaultAmount: undefined,
    };
    this.getLogo();
    this.getLogo = this.getLogo.bind(this);
    this.props.dispatch(dashboardActions.fetchProfileSummary());
    this.props.dispatch(dashboardActions.fetchSummary());
    // this.handleReadDataIP = this.handleReadDataIP.bind(this);
    // this.updateRequestList();
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  goToCreatePaymentRequest = () => {
    this.props.dispatch(push(`/paymentrequest`));
  };
  getLogo = async () => {
    const response = await controller.getLogo();
    this.setState({ serverLogo: response.data.dark });
  };
  processRequestsDataIntoRows = (rows) => {
    rows.forEach((payreq) => {
      let date = new Date(payreq.appointment_datetime);
      var options = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      payreq.processed_appointment_date = date.toLocaleString("en-GB", options);
      if (payreq.patient_phone) {
        let p = payreq.patient_phone;
        payreq.processed_phone_number = `${p.substr(0, 2)}-${p.substr(2, 3)}-${p.substr(5, 3)}-${p.substr(8, 4)}`;
      }
      let max_len = 80;
      if (payreq.reason) payreq.short_reason = payreq.reason.length > max_len ? payreq.reason.substr(0, max_len) : null;
    });
    return rows;
  };

  // handlePaginatorChange = (page, page_size) => {
  //   this.setState(
  //     {
  //       page,
  //       page_size,
  //     },
  //     () => this.updateRequestList()
  //   );
  // };

  searchDelayTimeout = null;
  // handleSearchChange = (e) => {
  //   const { value } = e.target;
  //   this.setState({ search_term: value }, function () {
  //     console.log("Search term updated:", this.state.search_term); // Log updated search term
  //     this.updateRequestList();
  //   });
  // };

  handleChangeGuarantor = async (value) => {
    const selectedAR = this.state.arList.find((ar) => ar.guarantor.id === value);
    const { amount_between_0_30, amount_between_31_60, amount_between_61_90, amount_greater_than_90 } = selectedAR;
    const arAmounts = [amount_between_0_30, amount_between_31_60, amount_between_61_90, amount_greater_than_90]
      .map((amount) => Number(amount.slice(1)))
      .reduce((cur, acc) => acc + cur, 0);

    this.setState({ selectedGuarantor: value, selectedAR, sumOfARAmounts: arAmounts });
  };

  updateRequestList = async () => {
    this.setState({ loading: true });

    console.log(this.props.selectedGuarantor);
    // if (!localStorage.getItem("selectedOffice")) return;

    const response = await controller.get_payment_requests(
      this.state.page_size,
      this.state.page,
      this.state.search_term || "",
      localStorage.getItem("selectedOffice"),
      false,
      this.props.selectedGuarantor
    );
    if (response.status < 250) {
      console.log(response);
      this.setState({ paymentRequests: response.results });
    } else {
      this.openNotification("bottom", response.detail ? response.detail : response.massage, "Error");
      if (response.detail) {
        this.setState({ errorMessage: response.detail });
      }
    }
    this.setState({ loading: false });
  };

  handleSyncData = async () => {
    try {
      this.setState({ isSyncing: true });

      const response = await controller.syncARCards(this.props.selectedPatient.id);

      if (response.status < 250) {
        this.getGuarantors();
      }
    } catch (err) {
      message.error("Something went wrong while syncing data");
      console.error(err);
    } finally {
      this.setState({ isSyncing: false });
    }
  };

  render() {
    // const { loadingSummary, summary, loadingRequests, requests, error, profileSummary } = this.props;
    const { loadingSummary, loadingRequests, requests, error } = this.props;
    // const Search = Input.Search;
    const className = "dashboard-container" + (loadingSummary || loadingRequests ? " is-loading" : "");

    const rows = requests && requests.results ? this.processRequestsDataIntoRows(requests.results) : [];
    let rows_id = {};
    // const rows_is_array = requests && requests.results ? requests.results.map((row) => (rows_id[row.id] = 0)) : {};

    if (this.state.isGettingCardsData)
      return (
        <Flex align="center" justify="center">
          <Spin size="large" />
        </Flex>
      );

    return (
      <div className={className}>
        {error && error.message && <div className="alert">{error.message}</div>}

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 30 }}>
          {/* <Typography.Title level={4}>Payment Request</Typography.Title> */}
          <Select
            options={this.state.guarantors}
            disabled={this.state.isGettingGuarantors}
            onChange={(value) => this.handleChangeGuarantor(value)}
            placeholder="Select Guarantor"
            className="ar-guarantor-dropdown"
            style={{ width: "20%" }}
            value={this.state.selectedGuarantor}
            filterOption={(input, option) => {
              if (!input) return true;
              if (!option.children) return false;

              const searchTerms = input
                .toLowerCase()
                .split(/\s+/)
                .filter((term) => term); // Split input by whitespace and remove empty terms
              const optionText = option.children.toLowerCase();

              // Return true if all search terms are found in the option's text
              return searchTerms.every((term) => optionText.includes(term));
            }}
          />

          <Flex align="center" gap={10}>
            <Button type="primary" loading={this.state.isSyncing} style={{ width: 150 }} onClick={() => this.handleSyncData()}>
              Sync
            </Button>

            {/* <Button
              style={{
                border: "1px solid #6B43B5",
                color: "#6B43B5",
                marginLeft: "auto",
                width: 154,
                height: 34,
              }}
              onClick={() => this.props.setCurrentStep(1)}
            >
              Back
            </Button> */}
          </Flex>
        </div>

        <Card style={{ width: "100%", marginBottom: 30 }}>
          <div className="payment-request-labels-container">
            <TreatmentPaymentLabel
              icon={money}
              data={`$${this.state.selectedAR ? Number(this.state.sumOfARAmounts).toFixed(2) : 0}`}
              label="Total Amount"
            />
            <div className="payment-request-ar-labels">
              <TreatmentPaymentLabel
                icon={cardTick}
                data={this.state.selectedAR ? this.state.selectedAR.amount_between_0_30 : "$0"}
                label="AR (0-29 Days)"
              />
              <TreatmentPaymentLabel
                icon={cardTick}
                data={this.state.selectedAR ? this.state.selectedAR.amount_between_31_60 : "$0"}
                label="AR (30-59 Days)"
              />
              <TreatmentPaymentLabel
                icon={cardTick}
                data={this.state.selectedAR ? this.state.selectedAR.amount_between_61_90 : "$0"}
                label="AR (60-89 Days)"
              />
              <TreatmentPaymentLabel
                icon={cardTick}
                data={this.state.selectedAR ? this.state.selectedAR.amount_greater_than_90 : "$0"}
                label="AR (+90 Days)"
              />
            </div>
          </div>
        </Card>

        <div style={{ backgroundColor: "#ffffff", minHeight: "calc(100% - 100px)", borderRadius: 2 }}>
          {this.state.loading ? (
            <div className="loading-spinner">
              <Spin />
            </div>
          ) : (
            <div style={{ marginTop: 30 }}>
              <div style={{ width: " 100%", display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 30 }}>
                <Typography.Title level={4}>{this.state.showPaymentRequestForm ? "Payment Request" : "Payment Requests History"}</Typography.Title>

                {!this.state.showPaymentRequestForm ? (
                  <Button type="primary" onClick={() => this.setState({ showPaymentRequestForm: true })}>
                    Send Payment Request
                  </Button>
                ) : (
                  <Button
                    style={{ borderRadius: 100, border: "1px solid #6b43b5", padding: "2px 20px", color: "#6b43b5" }}
                    onClick={() => this.setState({ showPaymentRequestForm: false })}
                  >
                    Back
                  </Button>
                )}
              </div>

              <div>
                {this.state.showPaymentRequestForm ? (
                  <PaymentRequestPage
                    selectedPatient={this.props.selectedPatient}
                    defaultAmount={this.state.defaultAmount}
                    selectedAR={this.state.selectedAR}
                  />
                ) : (
                  !this.state.isGettingGuarantors && (
                    <PaymentRequestsTable
                      // search_term={`${this.props.selectedPatient.first_name} ${this.props.selectedPatient.last_name}`}
                      rows={rows}
                      rows_id={rows_id}
                      selectedGuarantor={this.state.selectedGuarantor}
                      paymentRequestTableData={this.state.paymentRequests}
                    />
                  )
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loadingSummary, summary, profileSummary, loadingRequests, requests, error } = state.dashboard;
  return {
    loadingSummary,
    summary,
    profileSummary,
    loadingRequests,
    requests,
    error,
    authentication: state.authentication,
  };
}

const connectedDashboardPage = connect(mapStateToProps)(DashboardPage);

export default withRouter(connectedDashboardPage);
